import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { useScrollSpy } from '../hooks/useScrollSpy'; 
import Box from '@mui/material/Box';
import Sidebar1Depth from './Sidebar1Depth';

// 페이지 컴포넌트 임포트
import About from '../pages/About';
import Product from '../pages/Product';
import Gallery from '../pages/Gallery';
import Reservation from '../pages/Reservation';
import QnA from '../pages/QnA';

export default function ContainerFluid(props) { 
  const { open, onClose, ...other } = props;
  
  // 1. 스크롤이 발생하는 컨테이너를 잡기 위한 Ref
  const scrollContainerRef = useRef(null); 
  
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation(); // 주소창 정보를 가져옴
  const navigate = useNavigate(); // 페이지 이동을 위해 사용  
  const sectionIds = ['gallery', 'product', 'about', 'reservation', 'qna'];
  
  // 2. PC용 스크롤 감지 훅 호출 (ref 전달)
  const scrolledSection = useScrollSpy(sectionIds, isMobile, scrollContainerRef);
  
  // 3. 현재 활성화될 섹션 결정 (모바일은 URL 기준, PC는 스크롤 기준)
  const activeSection = useMemo(() => {
    if (isMobile) {
      const path = location.pathname.substring(1); 
      return path || 'gallery'; 
    }
    return scrolledSection;
  }, [isMobile, location.pathname, scrolledSection]);

  // 4. 화면 크기 변화 감지 로직
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      if (mobile !== isMobile) {
        setIsMobile(mobile);

        // 모바일 -> PC 전환 시, 현재 경로를 해시로 바꿔서 스크롤 위치 보정
        if (!mobile && location.pathname !== '/') {
          const sectionId = location.pathname.substring(1);
          navigate(`/#${sectionId}`, { replace: true });
        }
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobile, location.pathname, navigate]);

  const navItems = [
    { id: 'gallery', element: <Gallery /> },
    { id: 'product', element: <Product /> },
    { id: 'about', element: <About /> },
    { id: 'reservation', element: <Reservation /> },
    { id: 'qna', element: <QnA /> },
  ];

  return (
    <Box 
      component="main"
      className={"container-fluid " + (open ? "hidden" : "")}
      {...other}
    >
      {/* 사이드바에 계산된 activeSection 전달 */}
      <Sidebar1Depth activeSection={activeSection} isMobile={isMobile} onDrawerToggle={onClose} />
      
      <main className='container' ref={scrollContainerRef}>
        <Routes key={isMobile ? 'mobile' : 'desktop'}>
          {isMobile ? (
            /* 모바일 모드: 각 페이지를 독립적으로 렌더링 */
            <>
              {navItems.map((item) => (
                <Route key={item.id} path={`/${item.id}`} element={item.element} />
              ))}
              <Route path="/" element={<Gallery />} />
            </>         
          ) : (
            /* PC 모드: 모든 섹션을 한 페이지에 세로로 나열 */
            <Route 
              path="*" 
              element={
                <div className=''>
                  {navItems.map((item) => (
                    <section id={item.id} key={item.id}>
                      {item.element}
                    </section>
                  ))}
                </div>
              } 
            />
          )}
        </Routes>
      </main>
    </Box>
  );
}